import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import img1 from '../../assets/course/12101001.jpg'
import img2 from '../../assets/course/12101002.jpg'
import img3 from '../../assets/course/12101003.jpg'
import tr1 from '../../assets/others/11102067.webp'
import img4 from '../../assets/others/11102069.jpg'
import Accordion from 'react-bootstrap/Accordion'
import Companysec from '../../Components/Companysec/Companysec'
import Offersec from '../../Components/Offersec/Offersec'
import icncheck from '../../assets/icons/check-circle-bl.svg'
import instimg from '../../assets/others/11102038.jpg'
import Enrollaction from '../../Components/Enrollaction/Enrollaction'
import "react-multi-carousel/lib/styles.css";
import Partnersec from '../../Components/Partnersec/Partnersec'
import Videoreview from '../../Components/Videoreviewsec/Videoreview'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Whysec from '../../Components/Whysec/Whysec'
library.add(fas)

const onButtonpdf = () => {
    const pdfUrl = "../../brochuer/Analog-Layout-Design-Brochure.pdf";
    window.open(pdfUrl);
};

const Analoglayout = () => {
  return (
    <div>
          <Helmet>
          <title>Analog Layout Training Institutes | Custom Layout Design Courses| Physical Verification and Analog IC Design Training | Takshila VLSI</title>
          <meta name="description" content="Join top Analog Layout Training Institutes at Takshila VLSI. Custom Layout Design, Physical Verification, and Analog IC Design courses with placement assistance." />
          <link rel="canonical" href="https://www.takshila-vlsi.com/product/analog-layout-design/" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Analog Layout Training Institutes | Custom Layout Design Courses| Physical Verification and Analog IC Design Training | Takshila VLSI" />
          <meta property="og:description" content="Join top Analog Layout Training Institutes at Takshila VLSI. Custom Layout Design, Physical Verification, and Analog IC Design courses with placement assistance." />
          <meta property="og:url" content="https://www.takshila-vlsi.com/product/analog-layout-design/" />
          <meta property="og:site_name" content="Takshila VLSI" />
          <meta property="article:modified_time" content="2024-08-10T07:34:09+00:00" />
          <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2018/12/shutterstock_673252519.jpg" />
          <meta property="og:image:width" content="1000" />
          <meta property="og:image:height" content="650" />
          <meta property="og:image:type" content="image/jpeg" />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
          <Header/>
      <main>
          <section class="section-banner pg-banner ws-section pt-5 bg-14">
          <div class="container text-center">
                      <div class="row justify-content-around p-lg-5 pb-0">
                          <div class="col-md-9">
                              <div class="pg-title-sec">
                                  <h1 className='pg-title pb-3'>Analog Layout 
                                  <span className='bg-txt mx-3'>Design</span> 
                                  </h1>
                                  <p className='pg-title-desc mb-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.</p>
                              </div>
                          </div>
                          <div class="col-md-12 align-self-center mb-3">
                                  <a href="/register-now">
                                      <button class="btn-primary btn-icon">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                  </a>
                          </div>
                      </div>
                      <div class="row justify-content-center img-radius g-3">
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img1} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-8 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners feel more confident when applying for jobs</p>
                              </div>
                          </div>
                          <div class="col-md-3 align-self-end">
                          <img src={img2} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-7 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners became better at their job</p>
                              </div>
                          
                          </div>
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img3} alt=''/>
                          </div>
                      </div>
          </div>
      </section>
      <section className='course-desc p-lg-5 bg-14 pt-5'>
              <div class="container text-center">
                      <div class="row justify-content-around text-center">
                          <div class="col-md p-lg-5">
                                  <h1 className='ws-section_heading pd-03'><span className='font-thin'>Custom Layout Design Courses & Analog Layout Design Training
                                  </span> Courses in Bangalore/ Hyderabad</h1>
                          </div>
                      </div>
                      <div class="row justify-content-around">
                          <div class="col-md">
                                  <h3 className='pb-3 txt-3'>COURSE DESCRIPTION</h3>
                                  <div className='text-left text-xl'>
                                  <p>Analog Layout Design / Custom Layout Design / IC design training course mainly focused on giving hands-on practical exposure in doing chip layout design for a given analog &amp; mixed signal design. By end of the course you will learn to work in Linux environment, schematic entry in EDA tool, placement planning, analog and digital layout design, routing and physical verification checks like DRC, LVS for typical analog circuits such as Opamp, PLL, Bandgap, LDO and standard cells. You will also understand fixing deep sub-micron process issues like Antenna, Latchup, EM&amp;IR.</p>
                                  <p>Course also focus on giving insights of the Analog circuit design and Simulation, IO Layout Training, Memory Layout Training as well. After completing the course, you will get opportunity to move into domains such as Analog &amp; Mixed Signal Layout Design, Memory Layout Design, Standard Cell Layout Design, and I/O Layout Design.</p>
                                  </div>
                          </div>
                      </div>
              </div>
      </section>
      <section className='highlight-section p-lg-5 bg-14 p-2'>
          <div class="container bg-9 p-lg-5 p-3 radius-1">
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Eligibility</div>
              <div class="row row-cols-2">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>B.E/B.Tech in ECE/EEE.</div>
                  </div>
                  </div>
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>M.E/M.Tech/M.S in VLSI System Design/Embedded Systems/Digital Electronics.
</div>
                  </div>
                  </div>
              </div>
              </div>
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Course Duration</div>
              <div class="row row-cols-2">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>4 Months</div>
                  </div>
                  </div>
              
              </div>
              </div>
              <div>
              <div className='txt-2 mb-2'>Course Highlights</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Deep understating of MOSFET device physics and various key analog circuit designs.</div>
                  </div>
              
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Practical understanding of matching, shielding techniques.</div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Hands on exposure in fixing layout violations such as DRC, LVS, Antenna, Latchup, EM&IR.</div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Hands on experience in standard cell layout design, I/O Layout design, Memory Layout Design.
                      </div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Critical Industry standard project execution under the guidance of 12+ year’s industry expert.</div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>24×7 Lab Support with Lab practice handouts and course material delivery.
                      </div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Soft skills development, job oriented analog layout design training with 100% placement assistance.
                      </div>
                  </div>
                  
                  </div>
              </div>
              </div>
                  
          </div>
      </section>

      <section className='author-section p-lg-5 p-2 bg-14'>
      <div className='container'>
      <div class="row">
              <div class="col-lg-9 align-self-center bg-3 dark-bg p-lg-5 p-3 mr--10 mt-5 mb-3">
              <h2 class="ws-section_heading mb-3">About Instructors</h2>
              <a href='/teachers/ram/'><h4>Mr.Ram</h4></a>
              <h6 className='pb-3'>(Analog Layout Design Expert)</h6>
              <p>A VLSI Professional with 15+ years of rich experience in Analog Mixed-signal Layout design. Worked with Tier 1 Semiconductor Product and Service companies and also Product based startup companies which helped me to understand the learning curves and business models. Having facilitative leadership skills and having a proven track record with leading teams on-site &amp; offshore design centers.</p>
              <p>I believe “Experience comes from doing the same things repeatedly. But expertise will come only when you do the same thing in the different approaches” I strongly believe more in Expertise than experience.</p>

              <div class="wpb_wrapper">
              <div class="row g-3">
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Expertise Areas:</strong></p>
                      <ul>
                        <li>AMS IP layout design.</li>
                        <li>Memory layout design.</li>
                        <li>Module based floorplanning techniques.</li>
                        <li>Full chip / Block integration.</li>
                        <li>Physical verification (LVS, DRC, ERC, Antenna fix, soft checks, stress &amp; CLDRC).</li>
                        <li>Signal integrity / Cross talk and Static IR drop analysis.</li>
                        <li>All Other deep submicron issues like STI, WPE, and LOD.</li>
                        </ul>

                        <p><strong>Technology Process Worked On:</strong></p>
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Finfet Technologies:</strong> 7nm, 10nm, 14nm, 16nm, and 22nm.<strong><br/><br/>
                      Nominal Technologies: </strong>28nm, 32nm, 40nm, 65nm, 90nm,130nm, 180nm &amp; 440nm.<br/>
                      <strong><br/>
                      IC Foundries Worked with:&nbsp;</strong>TSMC,&nbsp;UMC,&nbsp;GF, SAMSUNG, ST, INTEL</p>
                  
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>EDA tools known for layout design :</strong> Cadence VLE, L, XL, and GXL and Mentor Graphics IC-Station<strong>.<br/>
                      <br/>
                      Physical verification tools known: </strong>Calibre, Assura, PVS and Hercules.</p>
                      </div>
                  </div>
                      </div>
              </div>
              <div class="col-lg img-radius">
              <img src={instimg} alt=''/>
              </div>
          </div>
          </div>
      </section>

      <section className='curriculum-section pt-5'>
          <div className='container'>
              <div class="row justify-content-center mb-5">
              <div class="col-lg-8 text-center">
              <h3 class="ws-section_heading pb-03 txt-3">IC Design Training / Chip Layout training / Custom Layout Training
              </h3>
              </div>
              </div>
              <div class="row mb-5">
                  <div class="col-lg-8">
                  <div class="ws-section_heading pb-03 txt-3 mb-lg-0">Course Curriculum</div>
                  </div>
                  <div class="col-lg-4 align-self-center">
                  <button class="btn-primary btn-icon" onClick={onButtonpdf}>Download Brochure<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                  
                  </div>
              </div>
              <div className='row'>
                  <div className='col-lg'>
                  <div className='curriculum-accord accordion'>
                          <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="0">
                              <Accordion.Header>Module 1: Analog, Digital Electronics & MOSFET
Theory</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Analog Electronics</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Introduction to MOSFET theory and second order effects</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Digital Electronics </div>
                              </div>
                          </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                              <Accordion.Header>Module 2: Introduction to CMOS Process and Circuits</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>CMOS Fabrication Process </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>CMOS Circuits and Stick Diagrams </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                              <Accordion.Header>Module 3: Basics of Unix/Linux</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Introduction to Unix/Linux Commands </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>VI Editor Commands 
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                              <Accordion.Header>Module 4: EDA Tool Introduction</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Introduction to Cadence Tool
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>DRC, LVS, ERC fixing using tool
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Physical Verification
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                              <Accordion.Header>Module 5: Design for Manufacturability Checks</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Latch-up
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Antenna Effect 
                                  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Electro-migration (EM)
                                  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>IR Drop & Self-Heat (SH)
                                  </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                              <Accordion.Header>Module 6: Deep sub-micron process challenges</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Shallow trench Isolation (STI)
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Length of Diffusion (LOD)
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Well proximity Effect (WPE)
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Metal Density effects
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>ESD
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="6">
                              <Accordion.Header>Module 7: STD cell Layout design Techniques</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Critical signals shielding techniques
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Basic STD cells understanding
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>NAND, NOR, AND, OR, INV1X & IV4X layout design
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="7">
                              <Accordion.Header>Module 8: Analog Layout Design Techniques</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Mismatch and Need for Matching
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Matching Techniques Common centroid & Interdigitation
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Guard / Seal Ring Techniques
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Analog Design Layout considerations
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Constraint & Module based Fullchip level floor planning techniques
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="8">
                              <Accordion.Header>Module 9: Industry standard Projects execution till tape-out</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Layout Design & Physical Verification of Casdode Opamp
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Layout Design & Physical Verification of Flash ADC blocks
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Layout Design & Physical Verification of Bandgap Reference
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Layout Design & Physical Verification of LDO
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="9">
                              <Accordion.Header>Module 10:  Memory Layout Design Concepts
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>6T Bit cell circuit theory and MEMORY architecture
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>ROW/COLUMN Decoder
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Sense Amplifier & Precharge circuits theory
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>DRAM Basics
                              </div>
                              </div>
                              </Accordion.Body>
                             
                          </Accordion.Item>
                          <Accordion.Item eventKey="10">
                              <Accordion.Header>Module 11: FinFET Concepts
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Introduction and Process methods of FinFET</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Process and reliability challenges</div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="11">
                              <Accordion.Header>Module 12: Mock Interviews & Personality Development
                              </Accordion.Header>
                          </Accordion.Item>
                          
                          </Accordion>
                          </div>
                  </div>
              </div>

          </div>
                  </section>

                  <section className='video-section p-lg-5 pt-4'>
          <div class="container text-center">
              <div className='row'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Analog Layout Design Demo Videos</h2>
              </div>
              </div>
              <div class="row justify-content-center">
                  <div class="col-lg-4">
                      <iframe
                          width="100%"
                          height="250"
                          src={`https://www.youtube.com/embed/1rNQoSFiOSg`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          title="Embedded youtube"
                          poster="hqdefault"
                      />
                  </div>
                  <div class="col-lg-4">
                  <iframe
                      width="100%"
                      height="250"
                      src={`https://www.youtube.com/embed/GLowIZ9bf5o`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Embedded youtube"
                      poster="hqdefault"
                  />
                  </div>
              </div>
          </div>
      </section>


                  <Companysec/>
                  <section className='ws-section pb-5 bg-white'>
                      <div class="container text-center">
                      <div class="row justify-content-around">
                                      <div class="col-lg-6">
                                          <div className='trainer-box'>
                                          
                                              <div className='trainer-img img-radius'>
                                              <img src={tr1} alt=''/>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="col-lg-6 text-left">
                                          <h2 className='mb-4'>4 Reasons That Make Our Analog Design Course the Greatest Of Them All</h2>
                                          <p>Yes! We are proud to say that our analog layout design training is the greatest of them all. Generally, analog design means circuit design. It involves converting specifications into transistor-level circuits, simulating, as well as verifying the design’s functionality and ensuring that it works on silicon.</p>
                                          <p>But circuit diagrams on paper or PCs can’t be manufactured thus comes the implementation part. Analog layout designers, who have undergone chip layout training, transform the circuit diagrams into polygons which are then utilized as masks for lithography steps to implementing the circuits on silicon. With the present level of technological advancement, it now demands lots more capabilities. It is these capabilities that we infuse into our students via our foremost analog layout design course. Some of the foremost reasons why our course is the greatest of them all include;</p>
                                          <div className='course-accord dark-bg'>
                                      <Accordion defaultActiveKey="0">
                                      <Accordion.Item eventKey="0">
                                          <Accordion.Header>1. The Foremost Analog Layout Training Institutes</Accordion.Header>
                                          <Accordion.Body>
                                          <p>We have some of the foremost analog layout training institutes you will ever find, around the whole world. We have spread our network for service provision quite wide. This is as we run the foremost analog layout training institutes in Bangalore as well as the foremost analog layout training institutes in Hyderabad. The main focus of our institutes is to make every single budding engineer understand the physical design of ICs from circuit to layout to tapeout, developing the right physical layout representation for every single analog function with in-blocks to enable the IC fabrication process.</p>
                                          <p>While studying this course with us, for each student, a lot more emphasis is placed on providing quality learning via lab practical that is backed by theoretical concepts that are taught by the foremost experts of the industry during classes as well as in laboratory sessions.</p>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="1">
                                          <Accordion.Header>2. What You Will Learn
                                          </Accordion.Header>
                                          <Accordion.Body>
                                          <p>Our analog layout training focuses mainly on providing hands-on practical exposure to executing a chip layout design for any given analog and mixed signal design. By the time you complete the course, you will understand how to work in Linux environments, placement planning, routing and physical verification checks such as DRC, LVS for usual analog circuits like PLL, LDO, Opamp, Bandgap, and standards cells, schematic entry into EDA tools, as well as analog and digital layouts design. Also, you will understand how to fix deep issues of sub-micron processes such as Latchup, Antenna, as well as EM&amp;IR.</p>
                                          <p>Also, our course focuses on providing insights into analog circuit design and simulation, memory layout training, and IO layout training. After you have completed your course, you are allowed to enter into other varying domains like standard cell layout design, analog, and mixed signal layout design, as well as IO layout design.</p>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="2">
                                          <Accordion.Header>3. Analog Layout Training with Placement</Accordion.Header>
                                          <Accordion.Body>
                                          One of our most unique features is that we offer layout design training with placement in some of the foremost firms in the whole world. Whether you choose to go for our custom layout training, IC design training, IO layout training, layout design training, memory layout training, or any of our other numerous analog and mixed signal layout courses, by the time you complete your studies, we provide you with 100% placement support. Our major aim is to help all engineers who graduate with us to build the most successful career they can in the VLSI industry.
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="3">
                                          <Accordion.Header>4. Our Affordable Costs</Accordion.Header>
                                          <Accordion.Body>
                                          <p>We offer the best low-cost analog layout training you will ever get throughout the entire industry. If you compare the cost of our courses to the quality of teachers, materials, as well as lab resources that we offer, then you will understand that our students get way more value than what they have paid. The analog design training that is offered by our layout training institutes in Bangalore is among the foremost training you will ever get, yet it’s offered at one of the lowest prices you can equally get in the entire industry. In fact, we even bundle our amazing finfet layout training into the course for our students. These are among the foremost reasons why the majority of VLSI students prefer to study with us.</p>
                                          <p>Layout engineers are the ones who are responsible for the development of layouts from scratch. So, they need to be properly trained. For this reason, we offer one of the greatest analog layout design courses you can ever get in the whole world. Our training are delivered using the most trending and unique methodologies and technologies. We ensure that our students eventually become real experts at what they do.</p>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      
                                      </Accordion>
                                      </div>
                                      </div>
                                  </div>
                      </div>
                  </section>
                  
      <Whysec/>           
      <Offersec/>

      <section className='corejob-section p-lg-5 pt-4 bg-14'>
              <div class="container text-center">
                              <div className='row pb-3'>
                                  <div className='col-lg text-center'>
                                  <h2 class="ws-section_heading">Core Job Opportunities</h2>
                              </div>
                              </div>
                              <div className='row g-3'>
                                  <div className='col-lg-4 mb-lg-4'>
                                  <div class="career-box d-flex p-3 radius-1 dark-bg">
                                              <h6>Analog Layout Design Engineer</h6>
                                              </div>
                                  </div>
                                  <div className='col-lg-4'>
                                  <div class="career-box d-flex p-3 radius-1 dark-bg">
                                              <h6>STD cell Layout Design Engineer</h6>
                                              </div>
                                  </div>
                                  <div className='col-lg-4'>
                                  <div class="career-box d-flex p-3 radius-1 dark-bg">
                                              <h6>I/O Layout Design Engineer</h6>
                                              </div>
                                  </div>
                                  <div className='col-lg-4'>
                                  <div class="career-box d-flex p-3 radius-1 dark-bg">
                                              
                                              <h6>Memory Layout Design Engineer</h6>
                                              </div>
                                  </div>
                                  <div className='col-lg-4'>
                                  <div class="career-box d-flex p-3 radius-1 dark-bg">
                                              
                                              <h6>RF Layout Design Engineer</h6>
                                              </div>
                                  </div>
                              </div>
                          </div>
      </section>

      <section className='ws-section pb-5 bg-white'>
          <div class="container text-center">
          <div className='row pb-3'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Connect With Us</h2>
              </div>
              </div>
          <div class="row justify-content-around">
                          <div class="col-lg-5">
                              <div className='trainer-box'>
                                  <div className='content-box wd-80 d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title text-left'>Join us & achieve <br/>
                                  your goals.</h5>
                                  </div>
                                  </div>
                                  <div className='trainer-img img-radius'>
                                  <img src={img4} alt=''/>
                                  </div>
                              </div>
                          </div>
                          <div class="col-lg-6">
                              
                              <iframe
                                  aria-label='Register Now'
                                  width="100%"
                                  height="850"
                                  src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                  frameborder="0" 
                              
                              />
                          
                          </div>
                      </div>
          </div>
      </section>

      
      <section className='course-faq-section ws-section p-lg-5 bg-14'>
          <div className='container'>
              <div className='row'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Frequently Asked Questions</h2>
              </div>
              </div>
              <div className='row justify-content-center pb-5'>
                  <div className='col-lg-10'>
                  <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="0">
                              <Accordion.Header>1. What is the duration of the Analog Layout Design course?</Accordion.Header>
                              <Accordion.Body><p>The course is 4 months long. Throughout the <strong>Analog Layout Design course</strong>, you will be given detailed instruction and practical exposure, along with many chances to enhance your skills in analog layout design.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                              <Accordion.Header>2. What kind of certification will you receive after the course?</Accordion.Header>
                              <Accordion.Body>
                              <p>After the course, you will receive a Takshila VLSI Certificate, acknowledging your proficiency in <strong>analog layout design education</strong>. Getting this certification can enhance your credentials and increase your competitiveness in the employment industry.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                              <Accordion.Header>3. Can I take this course if I am working?</Accordion.Header>
                              <Accordion.Body>
                              <p>Yes, This course is created to be flexible, providing weekend classes and lab access 24 hours a day, 7 days a week. It enables you to disrupt your present job while also advancing in <strong>learning analog layout design</strong>.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                              <Accordion.Header>4. How does this course prepare me for a career in Analog IC layout design?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our course prepares you by offering practical, real-world projects and extensive training in <strong>analog IC layout design</strong>. You’ll work with industry-standard tools and receive dedicated job placement assistance to help you secure a position in the field.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                              <Accordion.Header>5. What will your Analog Layout Design course teach?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our Analog Layout Design course will cover the fundamentals of <strong>VLSI analog layout design</strong>. It involves actual practice in schematic entry, placement planning, routing, and physical verification checks. The class includes basic and advanced subjects to prepare you for developing and testing analog ICs effectively.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                              <Accordion.Header>6. What is the fee structure of this course?</Accordion.Header>
                              <Accordion.Body>
                              <p>The price of the <strong>Analog layout design for the VLSI</strong> course is established at a competitive rate to provide excellent value. For additional details on fees and payment methods, contact us directly or visit our admissions webpage on the site. We offer various payment choices and financial assistance to help lower the cost of the course for everyone.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="6">
                              <Accordion.Header>7. What practical skills are developed through an Analog Layout Design course?</Accordion.Header>
                              <Accordion.Body>
Students learn layout planning, routing techniques, physical verification, matching concepts, shielding methods, and industry-standard design practices required for developing manufacturable chip layouts.                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="7">
                              <Accordion.Header>8. How can hands-on project work improve layout design skills?</Accordion.Header>
                              <Accordion.Body>
Practical projects help students apply theoretical concepts to real design challenges, understand layout optimization techniques, and gain experience with industry workflows. At Takshila VLSI, students work on industry-oriented projects under expert guidance to strengthen their practical skills.                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="8">
                              <Accordion.Header>9. Why is learning DRC and LVS important for layout design careers?</Accordion.Header>
                              <Accordion.Body>
DRC and LVS are critical verification processes that ensure a layout is manufacturable and accurately matches the intended circuit design before fabrication, making them essential skills for layout engineers.                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="9">
                              <Accordion.Header>10. What should students look for in a layout design training program?</Accordion.Header>
                              <Accordion.Body>
Students should look for practical lab sessions, industry-standard EDA tools, project-based learning, experienced trainers, and placement support. These are key elements emphasized by Takshila VLSI to help learners become job-ready.                              </Accordion.Body>
                          </Accordion.Item>
                          </Accordion>
                  </div>
              </div>
              <div class="row justify-content-center mt-5">
                      <div class="col-lg-9">
                          <div class="callaction-2">
                              <div class="row">
                              <div class="col-lg-7">
                                  <h1>Don't see your questions ? answered here?</h1>
                              </div>
                              <div class="col-lg-4 align-self-center text-center">
                              <a href="/contact-us/">
                              <button class="btn-primary btn-icon ms-0" href="index.html#about">Contact Us<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                              </a>
                              </div>
                              </div> 
                          </div>
                      </div>
                  </div>
          </div>
      </section>

      
      <Videoreview/>
      <Enrollaction/>
      <Partnersec/> 
      </main>
      <Footer/>
      </div>
  )
}

export default Analoglayout